<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect},
    data() {
        return {
            title: "Colegios",
            items: [
                {
                text: "Configuración",
                href: "/"
                },
                {
                text: "Colegios",
                active: true
                }
            ],
            colegioseleccionada: null,
            datoscolegios: [
            ],
            isLoading: false,                      //colegio seleccionada en el buscador
            colegioid_seleccion: '',                       //id colegio 
            colegioid_editar: {},                       //id colegio 
            habilitar_boton: false,  
            editing: false,
            eventos: [], // Eventos asociados
            ColegioNoExiste: false, // Eventos asociados,
            originalcolegio:'',
            CRMisButtonDisabled:false,
            isLoading:false,
            opciones:['Si','No'],
            estados:[],
            phoneerror1:'',
            phoneerror2:'',
            phoneerror3:'',
            emailError1:'',
            emailError2:'',
            estado:{}
        };
    },
    computed:{
        isEmailValid1() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegioid_editar.correo_colegio);
        },
        isEmailValid2() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegioid_editar.correo_colegio_2);
        }
    },
    methods:{
        validacion() {
            const campos = {
                nombre_director: 'Nombre Director',
                correo_colegio: 'Correo Director',
                telefono_director: 'Teléfono Director',
                telefono_colegio: 'Teléfono',
                nombre_orientador: 'Nombre Orientador',
                correo_colegio_2: 'Correo Orientador',
                telefono_orientador: 'Teléfono Orientador',
                colegio_visitado: '¿Colegio Visitado?',
                estado: 'Estado',
            };
            for (let campo in campos) {
                if (!this.colegioid_editar[campo]) {
                    this.msgval(campos[campo]);
                    return false;
                }
            }
            return true;//this.crear_evento();
        },
        validateEmail1() {
            if (this.colegioid_editar.correo_colegio && !this.isEmailValid1) {
                this.emailError1 = 'El correo electrónico no es válido.';
            } else {
                this.emailError1 = '';
            }
        },
        validateEmail2() {
            if (this.colegioid_editar.correo_colegio_2 && !this.isEmailValid2) {
                this.emailError2 = 'El correo electrónico no es válido.';
            } else {
                this.emailError2 = '';
            }
        },
        modificar_id(colegioseleccionada) {
            const colegio = colegioseleccionada;
            if (colegio) {
                this.colegioid_seleccion = colegio;
                this.originalcolegio = colegio;
                this.habilitar_boton = true;
            } else {
                this.habilitar_boton = false;
            }
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        toggleEdit() {
            this.originalcolegio = { ...this.colegioid_seleccion };
            if (this.editing) {
                //console.log('editar')
                if(this.validacion){
                    this.isLoading=true
                    this.colegioid_editar.estado_id = this.estado.codigo;
                    axios.post('/api/editar_colegio',this.colegioid_editar).then(res=>{
                        if(res.data.estado){
                            //this.sucursal=res.data.sucursal
                            this.msg(res.data.color,res.data.mensaje);
                            //console.log(res.data.mensaje)
                            this.isLoading=false
                            this.actualizarDesdeAPIExterna()
                            //window.location.reload(); 
                        }else{
                            this.msg(res.data.color,res.data.mensaje);
                            //console.log(res.data.mensaje)
                            this.isLoading=false
                        }
                    })
                }
            }
            this.editing = !this.editing;
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        consultarColegio() {
            //console.log('consultarColegio');
            const rbd = this.colegioseleccionada.rbd; // RBD del colegio seleccionado
            //console.log(rbd);
            axios.get(`/api/get_colegio/${rbd}`).then(response => {
                if(response.data.estado){
                    this.colegioid_seleccion = response.data.colegio;
                    this.eventos = response.data.colegio.eventos;
                    //console.log(this.colegioid_seleccion)
                    this.colegioid_editar=this.colegioid_seleccion;
                    this.colegioid_editar.id=this.colegioid_seleccion.id;
                    this.colegioid_editar.rbd=this.colegioid_seleccion.rbd;
                    this.colegioid_editar.direccion=this.colegioid_seleccion.direccion;
                    this.colegioid_editar.comuna=this.colegioid_seleccion.comuna;
                    this.colegioid_editar.provincia=this.colegioid_seleccion.provincia;
                    this.colegioid_editar.region=this.colegioid_seleccion.region;
                    this.colegioid_editar.telefono_colegio=this.colegioid_seleccion.telefono;
                    this.colegioid_editar.colegio_visitado=this.colegioid_seleccion.colegio_visitado;
                    this.estado=this.estados.filter(est=>est.codigo==this.colegioid_seleccion.estado_colegio)[0];
                    this.colegioid_editar.nombre_orientador=this.colegioid_seleccion.nombre_orientador;
                    this.colegioid_editar.correo_colegio_2=this.colegioid_seleccion.correo_colegio_2;
                    this.colegioid_editar.telefono_orientador=this.colegioid_seleccion.telefono_orientador;
                    this.colegioid_editar.nombre_director=this.colegioid_seleccion.nombre_director;
                    this.colegioid_editar.correo_colegio=this.colegioid_seleccion.correo_colegio;
                    this.colegioid_editar.telefono_director=this.colegioid_seleccion.telefono_director;
                    if (this.colegioid_seleccion.estado_colegio!=null) {
                        //this.colegioid_editar.estado=this.estados.find(est=>est.codigo==this.colegioid_seleccion.estado_colegio)
                    }
                    this.actualizarDesdeAPIExterna();
                    /*Swal.fire({
                        icon: "success",
                        title: "Buscando Colegio..",
                        text: "La información del colegio se ha actualizado correctamente.",
                        timer: 3000,
                        showConfirmButton: false
                    });*/
                }else{
                    // console.log('Error al consultar')
                    console.log("No existen datos del colegio: "+rbd);
                    this.colegioid_seleccion = false;
                    this.eventos = '';
                    this.ColegioNoExiste=true;
                }
            });
        },
        handleKeydown(event) {
            // Verifica si la tecla presionada es Enter o Enter del teclado numérico
            if (event.key == "Enter" || event.code == "Enter" || event.keyCode == 13) {
                event.preventDefault(); // Previene comportamientos predeterminados (como un submit en formularios)
                //this.consultarColegio();
            }
        },
        actualizarDesdeAPIExterna() {
            //console.log('actualizarDesdeAPIExterna');
            const rbd = this.colegioseleccionada.rbd;
            this.isLoading=true;
            this.CRMisButtonDisabled=true;
            axios.get(`/api/get_colegio_crm/${rbd}`).then(response => {
                if(response.data.estado){
                    this.colegioid_seleccion = response.data.colegio;
                    this.eventos = response.data.colegio.eventos;
                    Swal.fire({
                        icon: "success",
                        title: "Datos actualizados",
                        text: "La información del colegio se ha actualizado correctamente.",
                        timer: 3000,
                        showConfirmButton: false
                    });
                    this.isLoading=false
                    this.CRMisButtonDisabled=false
                }else{
                    console.log("Error al actualizar desde la API externa:");
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "No se pudo actualizar la información del colegio.",
                        timer: 3000,
                        showConfirmButton: false
                    });
                    this.isLoading=false
                    this.CRMisButtonDisabled=false
                }
            })
        },
        formatFecha(fecha) {
            if (!fecha) return "-";
            const opciones = { year: "numeric", month: "2-digit", day: "2-digit" };
            return new Date(fecha).toLocaleDateString("es-ES", opciones);
        },
        formatFechaHora(fecha) {
            if (!fecha) return "-";
            const opciones = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" };
            return new Date(fecha).toLocaleString("es-ES", opciones);
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento.codigo);
            window.location.href = "/web/configuracion/eventos";
        },
        crear_evento(evento){
            localStorage.setItem('colegio',JSON.stringify(this.colegioid_seleccion));
            window.location.href = "/web/configuracion/crearevento";
        },
        customLabel(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        customEstado(estado) {
            return `${estado.nombre}`;
        },
        fetchColegios(query) {
            if (query.length < 3) return; // Buscar después de escribir al menos 3 letras
            this.isLoading = true;
            axios.get(`/api/colegios?search=${query}`)
                .then(response => {
                this.datoscolegios = response.data.filter((colegio)=> colegio.valido==1);
                })
                .catch(error => console.error(error))
                .finally(() => this.isLoading = false);
        },
        buscarColegio() {
            console.log('Colegio seleccionado:', this.colegioseleccionada);
        },
        formatPhoneNumber1() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_director.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_director = "+" + digits;
        },
        validatePhoneNumber1() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_director.length !== 12) {
                this.phoneerror1 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror1 = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        formatPhoneNumber2() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_colegio.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_colegio = "+" + digits;
        },
        validatePhoneNumber2() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_colegio.length !== 12) {
                this.phoneerror2 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror2 = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        formatPhoneNumber3() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_orientador.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_orientador = "+" + digits;
        },
        validatePhoneNumber3() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_orientador.length !== 12) {
                this.phoneerror3 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror3 = "";
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);

            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        }
    },
    mounted(){
        axios.get(`/api/get_estado_colegios`).then(response => {
            this.estados = response.data.estados;
        });
        if (localStorage.getItem("colegio")) {
            const colegio = localStorage.getItem("colegio");
            this.colegioseleccionada=JSON.parse(colegio);
            localStorage.removeItem("colegio");
            this.consultarColegio();
        }
        
    },
    created() {
        this.isLoading=true
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.datoscolegios = response.data.colegios.filter((colegio)=> colegio.valido==1);
                if (localStorage.getItem("rbd_colegio")) {
                    const rbd_colegio = localStorage.getItem("rbd_colegio");
                    localStorage.removeItem("rbd_colegio");
                    this.colegioseleccionada=this.datoscolegios.find(colegio=>colegio.rbd==rbd_colegio)
                    this.consultarColegio();
                    this.actualizarDesdeAPIExterna();
                }
            }
        }
        ).catch(error => console.error(error)
        ).finally(() => this.isLoading = false);
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            
                            <div class="offset-md-2 col-md-8">
                                <label for="title">Buscar Colegio</label>
                                <p>Ingrese RBD</p>
                                <div class="row">
                                    <div class="col-md-10">
                                        <multiselect
                                            v-model="colegioseleccionada"
                                            :options="datoscolegios"
                                            :searchable="true"
                                            :loading="isLoading"
                                            :custom-label="customLabel"
                                            placeholder="Buscar colegio..."
                                            @search-change="fetchColegios"
                                            @select="consultarColegio"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                        >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2">
                                    <b-button variant="primary" block @click="buscarColegio">Buscar</b-button>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="colegioseleccionada">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12" v-if="colegioid_seleccion">
                                <div class="card mt-3 shadow-sm border-light">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h1 class="text-primary mb-4">{{ editing ?  colegioid_seleccion.nombre : colegioid_seleccion.nombre }}</h1>
                                                <div class="row" v-if="editing">
                                                    <div class="col-md-6">
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="rbd"> Nombre Director:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="direccion" v-model="colegioid_editar.nombre_director" class="form-control border-primary" @keydown="restrictInput_withspace">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Correo Director:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="ciudad" v-model="colegioid_editar.correo_colegio" class="form-control border-primary" @blur="validateEmail1">
                                                                <p v-if="emailError1" class="error text-primary">{{ emailErro1r }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Telefono Director:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="documento" v-model="colegioid_editar.telefono_director" class="form-control border-primary" @input="formatPhoneNumber1" @blur="validatePhoneNumber1" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror1" class="error text-primary">{{ phoneerror1 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="rbd"> Teléfono Colegio:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="name" v-model="colegioid_editar.telefono_colegio" class="form-control border-primary" @input="formatPhoneNumber2" @blur="validatePhoneNumber2" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror2" class="error text-primary">{{ phoneerror2 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Nombre Orientador:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="telefono" v-model="colegioid_editar.nombre_orientador" class="form-control border-primary" @keydown="restrictInput_withspace">
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Correo Orientador:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="email" id="email" v-model="colegioid_editar.correo_colegio_2" class="form-control border-primary" @blur="validateEmail2">
                                                                <p v-if="emailError2" class="error text-primary">{{ emailError2 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> Telefono Orientador:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="telefono" v-model="colegioid_editar.telefono_orientador" class="form-control border-primary" @input="formatPhoneNumber3" @blur="validatePhoneNumber3" @keydown="restrictToNumbers" maxlength="12">
                                                                <p v-if="phoneerror3" class="error text-primary">{{ phoneerror3 }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="telefono"> ¿Colegio visitado?:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="colegioid_editar.colegio_visitado"
                                                                    :options="opciones" 
                                                                    placeholder="Seleccionar curso" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label> Estado:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <label class="text-primary"> * Campo Obligatorio</label>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <multiselect
                                                                    v-model="estado"
                                                                    :options="estados" 
                                                                    placeholder="Seleccionar estado" 
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    :custom-label="customEstado"
                                                                    >
                                                                    <template v-slot:noOptions>
                                                                        <p>No hay opciones</p>
                                                                    </template>
                                                                    <template v-slot:noResult>
                                                                        <p>No se encuentra coincidencia</p>
                                                                    </template>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <div class="col-md-6">
                                                                <label for="rbd"> RBD:</label>
                                                            </div>
                                                            <div class="col-md-6 text-right">
                                                                <!-- <label for="pais" class="text-primary"> * Campo Obligatorio</label> -->
                                                            </div>
                                                            <div class="col-md-12">
                                                                <input type="text" id="pais" v-model="colegioid_editar.rbd" disabled class="form-control border-primary">
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Dirección:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.direccion" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Comuna:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.comuna" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Provincia:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.provincia" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Región:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.region" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Tipo Educación:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.tipo_educacion" class="form-control border-primary">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="pais"> Nivel Socioeconómico:</label>
                                                            <input type="text" id="pais" v-model="colegioid_editar.nivel_socioeconomico" class="form-control border-primary">
                                                        </div>
                                                    </div>
                                                    <div class="offset-md-9 col-md-3 mb-3">
                                                        <div class="mt-3 float-right">
                                                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </button>
                                                            <button @click="toggleEdit" class="btn btn-primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-else>
                                                    <div class="col-md-6 mb-3">
                                                        <p>
                                                            <span>Última actualización con CRM:</span>
                                                            <strong>{{ new Date(colegioid_seleccion.updated_at).toLocaleString() }}</strong>
                                                        </p>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <div class="mt-3 float-right">
                                                            <b-button variant="primary" @click="crear_evento">Crear Evento</b-button>
                                                            <b-button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </b-button>
                                                            <b-button @click="toggleEdit" variant="primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar' }}
                                                            </b-button>
                                                            <!-- <b-button
                                                                variant="success"
                                                                :disabled="colegioid_seleccion==false || CRMisButtonDisabled"
                                                                @click="actualizarDesdeAPIExterna"
                                                            >
                                                                Actualizar desde CRM
                                                            </b-button> -->
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <p class="font-size-16"><strong>RBD:</strong> {{ colegioid_seleccion.rbd }}</p>
                                                        <p class="font-size-16"><strong>Dirección:</strong> {{ colegioid_seleccion.direccion }}</p>
                                                        <p class="font-size-16"><strong>Comuna:</strong> {{ colegioid_seleccion.comuna }}</p>
                                                        <p class="font-size-16"><strong>Provincia:</strong> {{ colegioid_seleccion.provincia }}</p>
                                                        <p class="font-size-16"><strong>Región:</strong> {{ colegioid_seleccion.region }}</p>
                                                        <p class="font-size-16"><strong>Nombre Director:</strong> {{ colegioid_seleccion.nombre_director }}</p>
                                                        <p class="font-size-16"><strong>Correo Director:</strong> {{ colegioid_seleccion.correo_colegio }}</p>
                                                        <p class="font-size-16"><strong>Teléfono Director:</strong> {{ colegioid_seleccion.telefono_director }}</p>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <p class="font-size-16"><strong>Estado Colegio:</strong> {{ colegioid_seleccion.estado_colegio?estados.filter((es)=>es.codigo==colegioid_seleccion.estado_colegio)[0].nombre:'' }}</p>
                                                        <p class="font-size-16"><strong>¿Colegio visitado?:</strong> {{ colegioid_seleccion.colegio_visitado }}</p>
                                                        <p class="font-size-16"><strong>Teléfono Colegio:</strong> {{ colegioid_seleccion.telefono_colegio }}</p>
                                                        <p class="font-size-16"><strong>Sede asociada:</strong> {{ colegioid_seleccion.sede_asociada }}</p>
                                                        <p class="font-size-16"><strong>Propietario:</strong> {{ colegioid_seleccion.propietario }}</p>
                                                        <p class="font-size-16"><strong>Nombre Orientador:</strong> {{ colegioid_seleccion.nombre_orientador }}</p>
                                                        <p class="font-size-16"><strong>Correo Orientador:</strong> {{ colegioid_seleccion.correo_colegio_2 }}</p>
                                                        <p class="font-size-16"><strong>Teléfono Orientador:</strong> {{ colegioid_seleccion.telefono_orientador }}</p>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div v-if="eventos.length > 0">
                                                            <h3>Eventos Asociados</h3>
                                                            <div class="table-responsive">
                                                                <table class="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <!-- <th>Actividad</th> -->
                                                                            <th>N Inscritos</th>
                                                                            <th>Código</th>
                                                                            <th>Nombre Difusión</th>
                                                                            <th>Acciones</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="evento in eventos" :key="evento.id">
                                                                            <!-- <td>{{ evento.actividad }}</td> -->
                                                                            <td>{{ evento.cantidad_inscripciones }}</td>
                                                                            <td>{{ evento.codigo }}</td>
                                                                            <td>{{ evento.nombre_difusion }}</td>
                                                                            <td>
                                                                                <b-button size="sm" variant="primary" @click="ver_evento(evento)">Ver</b-button>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="ColegioNoExiste">
                                <div class="card mt-3 shadow-sm border-light">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <div class="card mt-3">
                                                    <div class="card-body">
                                                        <p>No se encontraron datos del colegio RBD {{ colegioseleccionada.rbd }}</p>
                                                        <b-button
                                                            class="mt-2 mr-2"
                                                            variant="success"
                                                            @click="actualizarDesdeAPIExterna"
                                                        >
                                                            Consultar CRM
                                                        </b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>